// extracted by mini-css-extract-plugin
export default {"button":"UserRoleChange-button-b514e243ef079f508eebac36a7ee6ed9"};